import React from 'react';
import { Button, Checkbox, Grid, Icon, Table } from 'semantic-ui-react';
import axios from 'axios';
import download from 'downloadjs';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';

import { toast, ToastContainer } from 'react-toastify';
import moment from "moment";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Students extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.onSelectRow = this.onSelectRow.bind(this);
        this.printExamApp = this.printExamApp.bind(this);
    }

    onSelectRow(id) {
        const row = this.props.students.find(el => el.id === id);
        this.props.onDataChange(row);
    }

    printExamApp() {
        let ids = this.props.selectedData.map(el => ({
            studentStudyProgramId: el.studentStudyProgramId,
            studentGradedActivityId: el.studentGradedActivityId
        }));
        let obj = {
            language: 'bs',
            //withLogo: false,
            ids
        };
        axios({
            method: 'post',
            url: '/documents/exam-application',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Štampanje nije izvršeno.');
            });
    }


    render() {
        const { selectedData, students } = this.props;
        return (
            <div>{ students.length ? <div><Table celled selectable compact>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell style={{ width: '100px' }}>
                            <Checkbox
                                type="checkbox"
                                name="checkAllButton"
                                value={selectedData.length === students.length}
                                onChange={this.props.selectAll}
                                checked={selectedData.length === students.length}
                                label="Označi sve"
                            />
                            <Checkbox
                                type="checkbox"
                                name="checkFilter"
                                onChange={this.props.selectFilter}
                                label="Označi položene"
                                checked={selectedData.length === this.props.passedStudents.length && selectedData.length !== 0}
                            />
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>
                            Prezime i ime studenta/ice
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>
                            Odsjek
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>
                            Studijski program
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Datum unosa ocjene
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Ocjena
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body> {students.map((el, index) =>
                    (<Table.Row onClick={() => this.onSelectRow(el.id)} key={el.id} className={selectedData.find(e => e.id === el.id) ? 'table-active' : ''}>
                        <Table.Cell verticalAlign="middle">
                            <Checkbox
                                name={el.id}
                                type="checkbox"
                                checked={this.props.selectedData.findIndex(e => e.id === el.id) > -1}
                            />
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <Grid columns={1} centered className="stackable">
                                <Grid.Row verticalAlign="middle">
                                    <Grid.Column width="9">
                                        <span >{el.lastName} {el.firstName}</span>
                                    </Grid.Column>
                                    <Grid.Column width="7" verticalAlign="middle" textAlign="right">
                                        <span style={{ color: '#a6a4a1' }}>{el.index}</span>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            {el.departments.map(e => (<div>{e.name}</div>))}
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle">
                            {/*inputDate: el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : '',*/}
                            {el.inputDate ? el.inputDate : ''}
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle">
                            {el.grade}
                        </Table.Cell>
                    </Table.Row>))}
                </Table.Body>
            </Table>
                <div style={{ float: 'right' }}>
                Označeno <b>{selectedData.length}</b> od <b>{students.length}</b>.
            </div>

            <br /><br />
                <div> <Button
                floated="right"
                icon
                labelPosition="left"
                primary
                onClick={() => {
                    this.printExamApp();
                }}
            >
                <Icon className="print" />
                Štampanje
            </Button></div>
            <br /><br /></div>
                :
            <div>Nema studenata na ovom ispitu.</div>}


                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamApplications/Students.js